export default __webpack_public_path__ + "static/img-1-46513abd39504506a47426fc6d5396ed.png";